<template>
    <v-row>
      <!-- <v-col rows="12" sm="4">
        <v-select
          :items="activeList"
          item-value="value"
          item-text="text"
          class="mt-3"
          :label="$t('monitoring.state')"
          v-model="activeFilter"
          dense
          outlined
        />
      </v-col> -->
      <v-col rows="12" sm="4">
        <v-autocomplete
          :items="integrationIDList"
          v-model="integrationIDFilter"
          class="mt-3"
          :label="$t('keywords.name')"
          dense
          outlined
        />
      </v-col>
      <v-col rows="12" sm="4">
        <v-select
          :items="processTypeList"
          item-value="value"
          item-text="text"
          v-model="processTypeFilter"
          class="mt-3"
          :label="$t('keywords.type')"
          dense
          outlined
        />
      </v-col>
    </v-row>
</template>
<script>
import IntegrationsUtils from './utils'

export default {
  name: 'Filters',

  props: { items: Array },

  // mounted () { this.setQueryParam({ activeFilter: true }) },

  computed: {
    allItemsOption () {
      return {
        text: this.$t('keywords.all'),
        value: ''
      }
    },
    activeFilter: {
      get () {
        const { activeFilter } = this.$route.query
        const states = { true: true, false: false }

        return states[activeFilter] ?? ''
      },
      set (activeFilter) { this.setQueryParam({ activeFilter }) }
    },
    integrationIDFilter: {
      get () {
        return this.$route.query.integrationIDFilter ?? ''
      },
      set (integrationIDFilter) { this.setQueryParam({ integrationIDFilter }) }
    },
    processTypeFilter: {
      get () {
        return this.$route.query.processTypeFilter ?? ''
      },
      set (processTypeFilter) { this.setQueryParam({ processTypeFilter }) }
    },
    integrationIDList () {
      return [this.allItemsOption, ...this.items.map(i => i.integrationID)]
    },
    activeList () {
      return [this.allItemsOption, ...this.items.map(this.getActiveItem)]
    },
    processTypeList () {
      return [this.allItemsOption, ...this.items.map(this.getProcessTypeItem)]
    }
  },

  methods: {
    getActiveItem ({ active }) {
      return {
        text: active ? this.$t('check.active') : this.$t('check.inactive'),
        value: active
      }
    },
    getProcessTypeItem ({ processType }) {
      return {
        text: this.$t(IntegrationsUtils.getProcessTypeKey(processType)),
        value: processType
      }
    },
    setQueryParam (obj) {
      const query = { ...this.$route.query, ...obj }
      this.$router.replace({ query })
    }
  }

}
</script>
